import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

const xsrfToken='XSRF-TOKEN'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getXSRFToken() {
  return Cookies.get(xsrfToken)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js